import { useCallback } from 'react';
import { get } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import { setDimension } from '../../../actions/systemOfMeasurement';

export const useMeasurePanel = () => {
    const currentLeg = useSelector((state) => get(state, 'screen.currentLeg'));
    const pathname = useSelector((state) => get(state, 'router.location.pathname'));
    const page = pathname.substring(1);
    const dispatch = useDispatch();

    const handleWeightUnitsChange = useCallback((dimension) => dispatch(setDimension({ dimension })), []);

    return {
        currentLeg,
        page,
        handleWeightUnitsChange,
    };
};
